/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { RecruiterAvailabilityShowResponse } from '../types/RecruiterAvailabilityShow'

/**
 * GET /interview-scheduling/availability
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterAvailabilityController.php RecruiterAvailabilityController::show
 */
export async function recruiterAvailabilityShow(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<RecruiterAvailabilityShowResponse>> {
	return axiosInstance.get('/interview-scheduling/availability', config)
}
